import { render, staticRenderFns } from "./TransferGoods.vue?vue&type=template&id=3a937c0a&scoped=true&"
import script from "./TransferGoods.vue?vue&type=script&lang=js&"
export * from "./TransferGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a937c0a",
  null
  
)

export default component.exports